import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { DynamicAttribute } from '../dynamic-attribute';
import { FormGroupDirective, ControlContainer } from '@angular/forms';
import { AttributeDirective } from '../directives/attribute.directive';
import { AttributeValue } from '../models/attribute-value';

@Component({
  selector: 'dynamic-form-group',
  templateUrl: './form-group.component.html',
  styleUrls: ['./form-group.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class FormGroupComponent implements OnInit {
  @Input() attributes: DynamicAttribute[] = [];
  @Input() index: number;
  @ViewChildren(AttributeDirective) attributeHosts: QueryList<AttributeDirective>;
  trackById = (_: number, item: DynamicAttribute) => item.definition.id;
  constructor(private parent: FormGroupDirective) { }

  ngOnInit() {
  }

  public _sort(): void {
    this.attributes = this.attributes.sort((a, b) => a.definition.listOrder - b.definition.listOrder);
  }


  public values(): AttributeValue[] {
    if (!this.parent.form.valid || this.attributes === undefined) return [];

    let result: AttributeValue[] = [];
    this.attributeHosts.forEach(attributeHost => {
      let attributeValue = new AttributeValue();
      attributeValue.attributeDefinitionId = attributeHost.dynamicAttribute.definition.id;
      attributeValue.value = attributeHost.value();

      result.push(attributeValue);
    });

    return result;
  }
}
